import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';

import { Tooltip, Link, Button, DataBlocks, I18n, ErrorBlock } from 'components';
import { formatUnitString } from 'utils/formatString';
import { fetchSasBalance, refetchData } from '../../actions';

import BalancesRow from './BalancesRow';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const AdditionalBalances = ({ additionalBalances, actions, ...props }) => {
  if (additionalBalances.data && additionalBalances.data.error) {
    return (
      <ErrorBlock
        title={<I18n path="home.additionalBalances.blockTitle" />}
        refreshAction={() => actions.refetchData('AdditionalBalances')}
      />
    );
  }

  if (!additionalBalances.data) {
    return null;
  }

  const reducedBalances = additionalBalances.data.reduce((array, additionalBalancesGroup) => (
    additionalBalancesGroup.data
      ? array.concat(additionalBalancesGroup.data)
      : array
  ), []);

  const sasBalance = Object.assign(
    additionalBalances.data.find((b) => b.alias === 'Sas') || {},
    props.sasBalance,
  );

  const handleClick = sasBalance?.isLoading ? () => {} : actions.fetchSasBalance;

  if (!reducedBalances.length && !sasBalance.alias) return null;

  return (
    <DataBlocks.Block
      title={<I18n path="home.additionalBalances.blockTitle" />}
    >
      <DataBlocks.Table>
        {reducedBalances.map((additionalBalance, index) => (
          <BalancesRow {...additionalBalance} key={index} />
        ))}

        {sasBalance.alias && (
          <DataBlocks.TableRow>
            <DataBlocks.TableCell className={cx('sasTextCell')}>
              <I18n path="home.additionalBalances.sasName" />
              <Tooltip>
                <I18n path="home.additionalBalances.sasTooltip" />
              </Tooltip>
            </DataBlocks.TableCell>
            {sasBalance.error ? (
              <DataBlocks.TableCell className={cx('sasTextCell')}>
                <div className={cx('sasError')}>
                  <I18n path="common.error500" />
                </div>
                <Link onClick={handleClick}>
                  <I18n path="common.retry" />
                </Link>
              </DataBlocks.TableCell>
            ) : (
              <DataBlocks.TableCell className={cx('sasTextCell')}>
                {sasBalance.data ? (
                  <>
                    {sasBalance.data.value === null || sasBalance.data.value === undefined
                      ? <I18n path="common.serviceDisconnected" />
                      : formatUnitString(sasBalance.data.value, sasBalance.data.currency || 'CURRENCY')}
                  </>
                ) : (
                  <Link onClick={handleClick}>
                    <I18n path="home.additionalBalances.sasShowLink" />
                  </Link>
                )}
              </DataBlocks.TableCell>
            )}
            <DataBlocks.TableCell className={cx('sasButtonCell')}>
              <Button className="default" href={sasBalance.addBalanceUrl}>
                <I18n path="home.additionalBalances.sasPayButton" />
              </Button>
            </DataBlocks.TableCell>
          </DataBlocks.TableRow>
        )}
      </DataBlocks.Table>
    </DataBlocks.Block>
  );
};

function mapStateToProps(state) {
  const { additionalBalances, sasBalance } = state.home;
  return { additionalBalances, sasBalance };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchSasBalance,
      refetchData,
    }, dispatch),
  };
}

AdditionalBalances.propTypes = {
  additionalBalances: PropTypes.object,
  sasBalance: PropTypes.object,
  actions: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalBalances);
